import React from 'react';
import { FiArrowLeft, FiDownload, FiClock, FiTrendingUp, FiCheckCircle, FiXCircle } from 'react-icons/fi';
import StatusBadge from '../../../components/StatusBadge';
import StatusActions from '../../../components/StatusActions';

const DetailHeader = ({
  workOrder,
  onBack,
  onDownloadInvoice,
  onDownloadWorkOrder,
  onStatusChange
}) => {
  const getPriorityColor = (priority) => {
    const colors = {
      'low': 'bg-gray-100 text-gray-800',
      'medium': 'bg-blue-100 text-blue-800',
      'high': 'bg-yellow-100 text-yellow-800',
      'urgent': 'bg-red-100 text-red-800'
    };
    return colors[priority] || 'bg-gray-100 text-gray-800';
  };

  const getPriorityIcon = (priority) => {
    const icons = {
      'low': FiClock,
      'medium': FiTrendingUp,
      'high': FiCheckCircle,
      'urgent': FiXCircle
    };
    return icons[priority] || FiClock;
  };

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center space-x-4">
        <button
          onClick={onBack}
          className="p-2 hover:bg-[var(--bg-secondary)] rounded-lg transition-colors"
        >
          <FiArrowLeft size={24} className="text-[var(--text-primary)]" />
        </button>
        <div>
          <h1 className="text-2xl font-bold text-[var(--text-primary)]">
            {workOrder.woNumber}
          </h1>
          <p className="text-[var(--text-secondary)]">{workOrder.projectName}</p>
        </div>
      </div>
      <div className="flex items-center space-x-2">
        <StatusBadge status={workOrder.status} size="md" workOrderId={workOrder.id} />
        
        <span className={`inline-flex items-center space-x-1 px-3 py-1 text-sm font-medium rounded-full ${getPriorityColor(workOrder.priority)}`}>
          {React.createElement(getPriorityIcon(workOrder.priority), { size: 16 })}
          <span>{workOrder.priority}</span>
        </span>
        
        <button
          onClick={onDownloadInvoice}
          className="flex items-center space-x-1.5 px-3 py-1.5 bg-purple-600 hover:bg-purple-700 text-white text-sm rounded-lg transition-colors"
          title="Download Invoice"
        >
          <FiDownload size={16} />
          <span>Invoice</span>
        </button>

        <button
          onClick={onDownloadWorkOrder}
          className="flex items-center space-x-1.5 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-lg transition-colors"
          title="Download Work Order"
        >
          <FiDownload size={16} />
          <span>WO</span>
        </button>
        
        <StatusActions 
          workOrder={workOrder} 
          onStatusChange={onStatusChange} 
        />
      </div>
    </div>
  );
};

export default DetailHeader;